import dayjs from 'dayjs';

export const dateValidation=(date: string):string=>{
    console.log("dateValidation",date)
    if(date==null || date===undefined || date==="")
    {
        return "";
    }
    return new Date(date).getFullYear() > 1985 ? dayjs(date).format('MM/DD/YYYY') : ""
} 